import { Cidade, Estado } from '@tivic-team/manager-ts/dist/grl';

export class CidadeDTO extends Cidade {

    estado: Estado

    constructor(estado?: Estado) {
        super()
        this.estado = estado
    }
}